import { render, staticRenderFns } from "./testOne.vue?vue&type=template&id=56d3dfd5&scoped=true&"
import script from "./testOne.vue?vue&type=script&lang=js&"
export * from "./testOne.vue?vue&type=script&lang=js&"
import style0 from "./testOne.vue?vue&type=style&index=0&id=56d3dfd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d3dfd5",
  null
  
)

export default component.exports